module.exports = __webpack_public_path__ + "img/defaultAvatar.b0535048.png";